<template>
  <div id="app">   
    <navbar/>
    <div >    
      <router-view/>
    </div>
    <div class="footer">
    <TheFooter/>
    </div>
  </div>
</template>

<script>
//import Navbar from './components/Navbar';
//import NewEmployee from './components/NewEmployee';
import navbar from '@/components/navbar.vue'
import TheFooter from '@/components/TheFooter'

export default {
  name: 'app',
   components: {
    navbar, 
    TheFooter  
  } 
};
</script>

<style>
nav {
  margin-bottom: 10px;
}
.footer{
 display: inline-block;
 width: 100%;

}
</style>
